module.exports = __webpack_public_path__ + "img/APPimg.7f671452.png";